import BlockPadding from '@/components/block-padding';
import common from '@/components/lexemes/common';
import Masonry from '@/components/masonry';

import Thumbnail from '../thumbnail';

export default function Grid({ data }: { data: any }) {
  return (
    <BlockPadding maxWidth="large">
      <Masonry columns={{ default: 3, tablet: 2, mobile: 1 }} gap={20}>
        {data?.map((story: any) => {
          const { title, excerpt, cardImage, slug, secondaryInfo, metIn } = story || {};
          return (
            <Thumbnail
              key={slug}
              title={title}
              excerpt={excerpt}
              image={cardImage}
              slug={slug}
              secondaryInfo={secondaryInfo}
              fixedHeight={false}
              metIn={metIn}
              buttonText={common.lxReadMore()}
            />
          );
        })}
      </Masonry>
    </BlockPadding>
  );
}
